export default {
    strings: {
        pluginNameGoogleDrivePicker: 'Google Drive',
    },
};
